import { createContext, useState, useCallback } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuthState] = useState(() => {
        // Try to load auth from localStorage on initial render
        const storedAuth = localStorage.getItem("auth");
        return storedAuth ? JSON.parse(storedAuth) : {};
    });
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || true);

    // Custom setAuth that also stores in localStorage
    const setAuth = useCallback((newAuth) => {
        setAuthState(newAuth);
        if (newAuth && Object.keys(newAuth).length > 0) {
            localStorage.setItem("auth", JSON.stringify(newAuth));
        } else {
            localStorage.removeItem("auth");
        }
    }, []);

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
